import ReactDOM from 'react-dom/client'

import { callMBankBridge } from 'shared/lib/mbank-bridge'
import { updateSafeAreaForAppVersion } from 'shared/lib/mbank-bridge/safe-area'
import { initSentry } from 'shared/services/sentry/index.ts'
import { metrikaInit } from 'shared/services/yandex'

import App from './App.tsx'
import './i18/i18.ts'
import './styles/general.scss'
import './styles/vars/_colors.scss'
import './styles/vars/_reset.scss'

const isDev = import.meta.env.VITE_PROJECT_IS_DEV

if (!Boolean(isDev)) {
  metrikaInit()
  initSentry()
}

function hideLoader() {
  const loader = document.getElementById('splashLoader')

  document.body.style.overflow = 'auto'

  if (loader) {
    loader.style.display = 'none'
  }
}

const startApp = () => {
  let isSplashVisible = true

  void callMBankBridge<{ version?: unknown }>('app.getVersion').then(
    (response) => {
      if (!isSplashVisible) return

      updateSafeAreaForAppVersion(
        response.ok ? response.result?.version : undefined,
      )
    },
  )

  ReactDOM.createRoot(document.getElementById('root')!).render(<App />)

  const idTimeout = setTimeout(() => {
    isSplashVisible = false
    hideLoader()

    clearTimeout(idTimeout)
  }, 1000)
}

startApp()
